import styled from "@emotion/styled";
import {
  TERTIARY_GREY,
  HEADING,
  BACKGROUND_LIGHT,
  OLD_BLUE,
  BLUE_LIGHT,
  SECONDARY_GREY,
} from "src/constants/colors";
import { BOX_SHADOW } from "src/constants/styles";
import { InformationIcon } from "src/assets/icons";
import Tooltip from "src/components/Tooltip";

const Container = styled.div`
  display: flex;
  width: 266px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  border-radius: 12px;
  border: 1px solid ${SECONDARY_GREY};
  background: ${BACKGROUND_LIGHT};
  box-shadow: ${BOX_SHADOW};
`;

const NewBadge = styled.div`
  display: flex;
  height: 15px;
  padding: 2px 4px;
  align-items: center;
  color: ${OLD_BLUE};
  border-radius: 5px;
  background: ${BLUE_LIGHT};
  font-size: 10px;
`;

const Title = styled.h3`
  display: flex;
  align-items: center;
  flex-direction: row;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: ${HEADING};
  gap: 6px;
`;

const Text = styled.p`
  font-size: 14px;
  line-height: 22px;
  color: ${TERTIARY_GREY};
`;

const InformationWrapper = styled.span`
  cursor: pointer;
`;

const TooltipContent = ({ title, text }: { title: string; text: string }) => (
  <Container>
    <Title>
      {title} <NewBadge>New</NewBadge>
    </Title>
    <Text>{text}</Text>
  </Container>
);

export default ({ title, text }: { title: string; text: string }) => {
  return (
    <Tooltip
      maxWidth={300}
      minDistance={20}
      tooltipContent={<TooltipContent title={title} text={text} />}
    >
      <InformationWrapper>
        <InformationIcon />
      </InformationWrapper>
    </Tooltip>
  );
};
